import React from 'react'
import {
  Modal,
  ModalContent,
  ModalClose,
  Loader,
  Image,
} from '@mc/design-system'
import { useTranslation, withI18nContext } from '@mc/i18n'

import classes from './ShareModal.module.scss'
import ShareModalButtons from './ShareModalButtons'
import CopyLinkInput from './CopyLinkInput'

import { Links } from '../lib/types'
import ShareModalButtonsMobile from './ShareModalButtonsMobile/ShareModalButtonsMobile'
import i18nInstance from '../i18n/i18nInstance'

type ShareModalProps = {
  show: boolean
  modalImage?: string | null
  modalImageAlt?: string
  modalTitle?: string
  onClose: () => void
  links: Links | null
  loading: boolean
  error?: boolean
  isNativeShare: boolean
  email: {
    subject: string
    body: string
  }
}

export const ShareModal = withI18nContext(i18nInstance)(({
  show,
  modalImage,
  modalImageAlt,
  modalTitle,
  onClose,
  links,
  loading,
  error,
  isNativeShare,
  email,
}: ShareModalProps) => {
  const { t } = useTranslation('@mc/share')

  return (
    <Modal
      size='medium'
      show={show}
      onClose={onClose}
      className={classes.shareModal}
    >
      <ModalContent aria-label={modalTitle || t('modal.title')}>
        <div className='mc-invert'>
          <ModalClose />
        </div>
        {modalImage && (
          <Image src={modalImage} height={200} alt={modalImageAlt} />
        )}

        <div className='mc-bg-light row justify-content-center'>
          <div className='mc-invert col-11 col-md-10 mc-text--center mc-my-9'>
            <h1 className='mc-text-h3 mc-px-9 mc-mx-2'>
              {modalTitle || t('modal.title')}
            </h1>
            {loading && (
              <Loader color='#596170' width='30' className='mc-mt-4' />
            )}

            {!loading &&
              !error &&
              links &&
              (isNativeShare ? (
                // fallback in case nativeShare fails
                <ShareModalButtonsMobile
                  links={links}
                  email={email}
                  onClose={onClose}
                />
              ) : (
                <div className={classes.shareButtons}>
                  <div className='d-block d-md-none'>
                    <ShareModalButtonsMobile
                      links={links}
                      email={email}
                      onClose={onClose}
                    />
                  </div>
                  <div className='d-none d-sm-none d-md-block'>
                    <ShareModalButtons
                      links={links}
                      email={email}
                      onClose={onClose}
                    />
                    <CopyLinkInput link={links.copy} id='share' />
                  </div>
                </div>
              ))}

            {error && <p className='mc-text--error mc-mt-6'>{t('error')}</p>}
          </div>
        </div>
      </ModalContent>
    </Modal>
  )
})
